<template>
    <el-dialog
        :title="$t('selectCoord')"
        :visible.sync="dialogVisible"
        top="5vh"
        :close-on-click-modal="false"
        @close="dialogClose"
        custom-class="map-dialog"
        center>
        <div class="content">
            <div class="search">
                <div class="search-form">
                    <el-input
                        prefix-icon="el-icon-search"
                        size="mini"
                        id="pac-input"
                        @input="inputChange"
                        v-model="addressName"
                        clearable>
                    </el-input>
                </div>
                <ul class="search-box" v-show="searchListShow">
                    <li class="search-item" v-for="item in searchList" :key="item.description">
                        <a href="javascript:void(0)" class="clickable" @click.stop="addSearchMarker(item.description)">{{ item.description }}</a>
                    </li>
                </ul>
            </div>
            <div id="map_container"></div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" size="mini" :disabled="disabled" @click="submitClick">{{ $t('confirm') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {Loader} from "@googlemaps/js-api-loader"

const loader = new Loader({
    apiKey: "AIzaSyCQKDCJyVg1JingI_RAUxlcn4rk-U72AQo",  //填写google控制台中的apikey
    version: "weekly",
    libraries: ['geometry', 'places', 'drawing']
});
// 输入框模糊查询
let searchBox = null
// 搜索地点和检索地点详细信息
let service = null
// 对请求进行地理编码
let geocoder = null

export default {
    name: "Map",
    props: {
        parentDialog: {
            type: Boolean,
            default: false
        },
        parentLongitude: {
            type: [Number, String],
            default: ''
        },
        parentLatitude: {
            type: [Number, String],
            default: ''
        },
    },
    data() {
        return {
            dialogVisible: false,
            addressName: '',
            map: null,
            latitude: '',
            longitude: '',
            address: '',
            markers: [],
            searchListShow: false,
            searchList: [],
            disabled: true,
        };
    },
    computed: {
    
    },
    watch: {
        parentDialog(val) {
            if (val) {
                this.initData()
            }
        },
        address(val) {
            if (val) {
                this.disabled = false
            } else {
                this.disabled = true
            }
        }
    },
    // 方法集合
    methods: {
        // 初始化数据
        initData() {
            this.dialogVisible = true
            this.addressName = ''
            this.searchList = []
            if (!this.map) {
                this.initMap()
            }
        },
        //初始化地图
        initMap() {
            const mapOptions = {
                center: {
                    lat: Number(this.parentLatitude) || 45.28,
                    lng: Number(this.parentLongitude) || 9.10
                },
                zoom: 12,
                disableDefaultUI: true
            };
            loader.load().then((google) => {
                this.map = new google.maps.Map(
                    document.getElementById("map_container"),
                    mapOptions
                );
    
                // 当用户已选择地址
                if (this.userLatitude && this.userLongitude) {
                    // 添加标记
                    this.addMarker(this.userLatitude, this.userLongitude)
                }
    
                // 点击标点
                google.maps.event.addListener(this.map, "click", (e) => {
                    // 添加标记
                    this.addMarker(e.latLng.lat(), e.latLng.lng())
                });
    
                searchBox = new google.maps.places.AutocompleteService()
                
                service = new google.maps.places.PlacesService(this.map)

                geocoder = new google.maps.Geocoder()
                
            }).catch((err) => {
                console.log(err);
            });
            
        },
        // 搜索
        inputChange (value) {
            if (!value) {
                this.searchList = []
                return
            }
            // searchBox 自动完成请求（模糊匹配）
            searchBox.getPlacePredictions({ input: value },
                (event, status) => {
                    if (status === 'OK') {
                        let list = event || []
                        this.searchList = list.filter(x => {
                            return {
                                place_id: x.place_id,
                                description: x.description
                            }
                        })
                        this.searchListShow = true
                    } else {
                        this.searchList = []
                    }
                }
            )
        },
        // 搜索添加标记
        addSearchMarker(address) {
            this.searchListShow = false
            // 获取经纬度
            this.switchCoordinate(address).then((res) => {
                this.addressName = address
                // 存储地址
                this.address = address
                // 存储经纬度
                this.latitude = res.lat
                this.longitude = res.lng
                // 先清除之前的标记
                this.deleteMarkers()
                // 添加标记
                let markerCenter = {
                    lat: res.lat,
                    lng: res.lng
                };
                this.map.setCenter(markerCenter)
                loader.load().then((google) => {
                    const marker = new google.maps.Marker({
                        position: markerCenter,
                        map: this.map
                    })
                    // 消息框
                    let infowindow = new google.maps.InfoWindow({
                        content: `<div>
                                <p>${this.$t('longitude')}: ${res.lng}</p>
                                <p>${this.$t('latitude')}: ${res.lat}</p>
                                <p>${this.$t('address')}: ${address}</p>
                              </div>`
                    });
                    infowindow.open(this.map, marker);
                    this.markers.push(marker)
                }).catch((e) => {
                    console.log(e);
                });
            })
        },
        // 转换经纬度
        switchCoordinate(address) {
            return new Promise(resolve => {
                loader.load().then((google) => {
                    new google.maps.Geocoder().geocode({'address': address}, (res) => {
                        if (res.length > 0) {
                            resolve({
                                lat: res[0].geometry.location.lat(),
                                lng: res[0].geometry.location.lng()
                            })
                        } else {
                            resolve({
                                lat: '',
                                lng: ''
                            })
                        }
                    })
                }).catch((e) => {
                    console.log(e);
                });
            })
        },
        
        // 添加标记
        addMarker(lat, lng) {
            // 存储经纬度
            this.latitude = lat
            this.longitude = lng
            // 先清除之前的标记
            this.deleteMarkers()
            // 添加标记
            let markerCenter = {
                lat: lat,
                lng: lng
            };
            this.map.setCenter(markerCenter)
            loader.load().then((google) => {
                const marker = new google.maps.Marker({
                    position: markerCenter,
                    map: this.map
                })
                // 详细地址
                this.switchAddress(lat, lng).then((res) => {
                    // 存储地址
                    this.address = res
                    // 消息框
                    let infowindow = new google.maps.InfoWindow({
                        content: `<div>
                                <p>${this.$t('longitude')}: ${lng}</p>
                                <p>${this.$t('latitude')}: ${lat}</p>
                                <p>${this.$t('address')}: ${res}</p>
                              </div>`
                    });
                    infowindow.open(this.map, marker);
                    this.markers.push(marker)
                })
            }).catch((e) => {
                console.log(e);
            });
        },
        // 清除之前的标记
        deleteMarkers() {
            for (let i = 0; i < this.markers.length; i++) {
                this.markers[i].setMap(null)
            }
            this.markers = []
        },
        // 转换地址
        switchAddress(lat, lng) {
            return new Promise(resolve => {
                loader.load().then((google) => {
                    new google.maps.Geocoder().geocode({'latLng': new google.maps.LatLng(lat, lng)}, (res) => {
                        if (res.length > 0) {
                            resolve(res[0].formatted_address)
                        } else {
                            resolve('')
                        }
                    })
                }).catch((e) => {
                    console.log(e);
                });
            })
        },
        
        // 确定
        submitClick() {
            let obj = {
                latitude: this.latitude,
                longitude: this.longitude,
            }
            this.$emit('parent-update', obj)
            this.dialogVisible = false
        },
        // 关闭弹窗
        dialogClose() {
            this.$emit('parent-close')
        }
    },
    // 创建完成
    created() {
    
    },
    // 挂载完成
    mounted() {
        // this.initMap()
    },
    
    // 销毁之前
    beforeDestroy() {
    }
};
</script>

<style lang="scss" scoped>
.content {
    .search {
        position: relative;
        .search-form{
            width: 100%;
            display: flex;
            overflow: hidden;
            .el-input{
                .el-input__inner{
                    height: 42px;
                }
            }
        }
        .search-box{
            position: absolute;
            top: 42px;
            left: 0;
            z-index: 9;
            width: 100%;
            max-height: 240px;
            overflow-y: auto;
            background: #FFFFFF;
            box-shadow: 0 6px 16px 0 rgba(0,0,0,0.2);
            .search-item{
                width: 100%;
                height: 45px;
                .clickable{
                    width: 100%;
                    height: 100%;
                    padding-left: 20px;
                    display: flex;
                    align-items: center;
                    font-size: 19px;
                    color: #181818;
                }
            }
        }
    }
    
    #map_container {
        width: 100%;
        height: 620px;
    }
}


</style>
